import { BasicEvent } from "~app/features/planera/events/BasicEvent";

export class CopyLeverantorsorderCompletedEventMessage extends BasicEvent {
    leverantorsorderId: number;
    targetLeverantorsorderId?: number;
    validationMessage?: string;
    static readonly $type = "CopyLeverantorsorderCompletedEventMessage";

    constructor() {
        super(CopyLeverantorsorderCompletedEventMessage.$type);
    }
}
